/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Spin, Form, Row, Col, Input, Checkbox, message} from 'antd';
import {modal} from 'icsoc-antd-ex';
import tWorkTimeActions from 'Actions/systemSetting/workTime';
import TimeSettingItem from './timeSettingItem';

import './editModal.less';

const {ModalSize} = modal;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 4}, wrapperCol: {span: 20}};

const defaultTime = {
  from: '06:00',
  to: '23:00',
};
function convertToState(data) {
  return ['一', '二', '三', '四', '五', '六', '日'].map((item, index) => {
    let {[(index + 1) % 7]: value} = data || {};

    value = Array.isArray(value) ? value : [value];
    value = value.filter(time => {
      const {from, to} = time || {};

      return !!(from && to);
    });

    const hasValue = !!value.length;
    const checked = !data && index < 5 ? true : hasValue;

    return {
      checked,
      week: item,
      time: hasValue ? value : [Object.assign({}, defaultTime)],
    };
  });
}

class EditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      timeSettingDataSource: convertToState(),
      confirmLoading: false,
    };
  }

  componentDidMount() {
    const {workTimeActions, editModalData: {id = ''} = {}} = this.props;

    if (id) {
      this.setState({
        loading: true,
      });
      workTimeActions
        .getEditModalData(id)
        .then(res => {
          const {payload: {code, data: {workTimeDetail = ''} = {}} = {}} =
            res || {};
          const workingStr = JSON.parse(workTimeDetail);
          const {working: timeDataSource} = workingStr;

          if (parseInt(code, 10) === 200) {
            this.setState({
              timeSettingDataSource: convertToState(timeDataSource),
            });
          }
        })
        .finally(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  // 校验工作时间名称
  checkWorkName = (rule, value, callback) => {
    const valueTrim = (value && value.replace(/^\s+|\s+$/g, '')) || '';

    if (valueTrim !== '') {
      if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,15}$/g.test(valueTrim)) {
        callback('时间名称只能由数字、字母、汉字和下划线组成！');
      }
    }

    callback();
  };

  // 点击确定
  handleSubmit = () => {
    const {
      editModalData: {id = ''} = {},
      pageStatus,
      form: {validateFields},
      getTableList,
      setEditModalVisible,
      workTimeActions,
    } = this.props;
    const {timeSettingDataSource} = this.state;

    // eslint-disable-next-line consistent-return
    validateFields((err, values) => {
      if (!err) {
        const hasEmpty = timeSettingDataSource.some(item => {
          const {checked, time = []} = item || {};
          const isEmptyTime = !!time.filter(
            (timeItem = {}) => !!(timeItem.from && timeItem.to),
          ).length;

          return checked && !isEmptyTime;
        });

        if (hasEmpty) {
          return message.error('时间段不得为空！');
        }

        const working = timeSettingDataSource.reduce(
          (accumulator, currentValue, currentIndex) => {
            const {checked, time} = currentValue || {};
            const data = checked ? {[(currentIndex + 1) % 7]: time} : {};

            return Object.assign(accumulator, data);
          },
          {},
        );

        if (JSON.stringify(working) === '{}') {
          return message.error('请至少勾选一项时间设置！');
        }
        const workTimeDetail = {
          working,
        };
        const {workName = ''} = values;
        const params = {
          ...values,
          id,
          workName: workName.trim(),
          workTimeDetail: JSON.stringify(workTimeDetail),
        };

        this.setState({
          confirmLoading: true,
        });
        workTimeActions
          .editWorkTime(params)
          .then(res => {
            const {payload: {code} = {}} = res || {};

            if (parseInt(code, 10) === 200) {
              setEditModalVisible();
              message.success(`工作时间${id ? '修改' : '添加'}成功！`);
              getTableList({...pageStatus});
            }
          })
          .finally(() => {
            this.setState({
              confirmLoading: false,
            });
          });
      }
    });
  };

  // 时间设置
  checkboxChange = list => {
    let {timeSettingDataSource} = this.state;

    timeSettingDataSource = timeSettingDataSource.map((item, index) => {
      if (list.includes(index)) {
        return {
          ...item,
          checked: true,
        };
      }

      return {
        ...item,
        checked: false,
      };
    });

    this.setState({
      timeSettingDataSource,
    });
  };

  // 时间设置-改变时间选择框
  changeTime = data => {
    const {groupIndex, index, type, value} = data || {};
    const {timeSettingDataSource} = this.state;

    if (!value) {
      message.error('时间段不得为空！');
    }

    timeSettingDataSource[groupIndex].time[index][type] = value;

    this.setState({
      timeSettingDataSource,
    });
  };

  // 时间设置-添加
  addTime = index => {
    const {timeSettingDataSource} = this.state;

    timeSettingDataSource[index].time.push({...defaultTime});
    this.setState({
      timeSettingDataSource,
    });
  };

  // 时间设置-删除
  delTime = data => {
    const {groupIndex, index} = data || {};
    const {timeSettingDataSource} = this.state;

    timeSettingDataSource[groupIndex].time.splice(index, 1);

    this.setState({
      timeSettingDataSource,
    });
  };

  render() {
    const {
      editModalData: {id = '', data: {workName = ''} = {}},
      form: {resetFields, getFieldDecorator},
      setEditModalVisible,
    } = this.props;
    const {loading, timeSettingDataSource, confirmLoading} = this.state;
    const checkedList = timeSettingDataSource
      .map((item, index) => {
        if (item.checked) {
          return index;
        }

        return null;
      })
      .filter(item => typeof item === 'number');

    return (
      <ModalSize
        className="workTime-editModal"
        title={`${id ? '修改' : '添加'}工作时间`}
        // zIndex="1002"
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={setEditModalVisible}
        confirmLoading={confirmLoading}
        afterClose={() => {
          resetFields();
        }}>
        <Spin spinning={loading}>
          <Form>
            <FormItem
              {...formItemLayout}
              label="时间名称"
              style={{marginBottom: 20}}>
              {getFieldDecorator('workName', {
                initialValue: id ? workName : '',
                rules: [
                  {validator: this.checkWorkName},
                  {
                    required: true,
                    whitespace: true,
                    message: '时间名称不能为空！',
                  },
                ],
              })(<Input maxLength="15" placeholder="请输入工作时间名称" />)}
            </FormItem>
            <FormItem {...formItemLayout} label="时间设置">
              {getFieldDecorator('workTimeDetail', {
                initialValue: checkedList,
                rules: [
                  {
                    required: true,
                    message: '请至少勾选一项时间设置！',
                  },
                ],
              })(
                <Checkbox.Group
                  className="time-setting"
                  onChange={this.checkboxChange}>
                  {timeSettingDataSource.map((item, index) => {
                    const {week, time} = item || {};

                    return (
                      <Row key={`TimeSetting-${index}`}>
                        <Col span={5}>
                          <Checkbox value={index}>{`星期${week}`}</Checkbox>
                        </Col>
                        <Col span={19}>
                          {time.map((timeItem, timeIndex) => (
                            <TimeSettingItem
                              key={`TimeSettingItem-${index}-${timeIndex}`}
                              groupIndex={index}
                              time={timeItem}
                              index={timeIndex}
                              changeTime={this.changeTime}
                              addTime={this.addTime}
                              delTime={this.delTime}
                            />
                          ))}
                        </Col>
                      </Row>
                    );
                  })}
                </Checkbox.Group>,
              )}
            </FormItem>
          </Form>
        </Spin>
      </ModalSize>
    );
  }
}

const mapStateToProps = ({systemSettingWorkTime}) => ({
  editModalData: systemSettingWorkTime.editModalData,
  pageStatus: systemSettingWorkTime.pageStatus,
});

const mapDispatchToProps = dispatch => ({
  workTimeActions: bindActionCreators(tWorkTimeActions, dispatch),
});

const EditModalWrap = Form.create()(EditModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditModalWrap);
